import type { WarningMapObject } from "../types";

export interface WarningRaw {
    id: string;
    x: number;
    y: number;
    label: string;
    [key: string]: unknown;
}

export function parseWarnings(
    warnings: WarningRaw[] | null | undefined,
): WarningMapObject[] {
    if (!Array.isArray(warnings)) return [];

    return warnings.map((warning) => ({
        id: warning.id,
        type: "warning",
        label: warning.label,
        x: warning.x,
        y: warning.y,
        interactive: true,
    }));
}
